const QUERIES = {
  USERS_LIST: 'user-list',
}

export {QUERIES}
